import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { tap, catchError, shareReplay } from 'rxjs/operators';
import { AppConstants } from 'src/app/constants/app-constants';
import { AuthService } from 'src/app/services/auth.service';
import { HttpService } from 'src/app/services/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ScheduleStoreService {
    private multiScheduleItemData: any = [];
    private scheduleData: any = {};
    private scheduleItemData: any = {};
    private selectedRails: any = {};

    private authData: any;

    private scheduleSubject = new Subject();
    schedule$: Observable<any> = this.scheduleSubject.asObservable();

    private platformData: any = [];
    private productData: any = [];
    private screenData: any = [];
    private currentId: any = '';

    androidNoteData: any = [];

    constructor(private auth: AuthService, private http: HttpService) {
        this.authData = this.auth.getAuthData();
    }

    getCurrentId() {
        return this.currentId;
    }

    setCurrentId(id: any) {
        this.currentId = id;
    }

    getScheduleFilter() {
        return this.scheduleData;
    }

    setScheduleFilter(days: any, startdate: any, enddate: any, starttime: any, endtime: any) {
        this.scheduleData = {
            ...(days.length > 0 && { days }),
            ...(startdate && { startdate }),
            ...(enddate && { enddate }),
            ...(starttime && { starttime }),
            ...(endtime && { endtime }),
        };

        console.log('scheduleData', this.scheduleData);
    }

    getItemScheduleFilter() {
        return this.scheduleItemData;
    }

    resetItemScheduleFilter() {
        this.scheduleItemData = {};
    }

    setItemScheduleFilter(categoryId: string, items: any, schedule: any, type: any, autoUpdateItem: any) {
        console.log('items schedule set:', categoryId, items, schedule, autoUpdateItem);
        if (!this.scheduleItemData.hasOwnProperty(categoryId)) {
            console.log('Hiiiiiiiiiiiiiii');
            this.scheduleItemData[categoryId] = {};
        }

        if (schedule && Object.keys(schedule).length > 0) {
            if (type == 'schedule') {
                console.log('schedule');
                // let mergedItemsSchedule = items.map((item: any) => {
                // item.schedule = [schedule];
                // item.schedule = [schedule];
                //     return item;
                // });

                this.scheduleItemData[categoryId].items = items;
                this.scheduleItemData[categoryId].schedule = schedule;
                this.scheduleItemData[categoryId].autoUpdateItem = autoUpdateItem;
            } else if (type == 'scheduleItems') {
                let itemId = items.id;
                let item = this.scheduleItemData[categoryId].items?.find((item: any) => item.id == itemId);
                console.log(item);
                // let obj = { ...items };
                // if (Array.isArray(schedule)) {
                //     console.log('array is ajhsfkhlasfblkasfljkasbflkjasbflkasbljgfbaedklgbadkbgjkadnklgbadklgbadklbg');
                //     obj.schedule = schedule;
                // } else {
                //     console.log(
                //         'array is not ajhsfkhlasfblkasfljkasbflkjasbflkasbljgfbaedklgbadkbgjkadnklgbadklgbadklbg'
                //     );
                //     obj.schedule = [schedule];
                // }
                // console.log(obj);

                if (item) {
                    console.log('inside if');
                    if (Array.isArray(schedule)) {
                        item.schedule = schedule;
                    } else {
                        item.schedule = [schedule];
                    }

                    // item.schedule = schedule;
                } else {
                    console.log('inside else');
                    items.schedule = schedule;
                    console.log(items);
                    console.log(this.scheduleItemData[categoryId]);
                    if (Array.isArray(schedule)) {
                        items.schedule = schedule;
                    } else {
                        items.schedule = [schedule];
                    }
                    if (this.scheduleItemData[categoryId].items) {
                        this.scheduleItemData[categoryId].items.push(items);
                    } else {
                        this.scheduleItemData[categoryId].items = [items];
                    }
                }
            }
            // // this.scheduleItemData[categoryId] = mergedItemsSchedule;
            // this.scheduleItemData[categoryId].items = mergedItemsSchedule;
            // this.scheduleItemData[categoryId].schedule = schedule;
        } else {
            //this.scheduleItemData[categoryId] = items;
            if (type == 'schedule') {
                console.log('schedule');

                this.scheduleItemData[categoryId].items = items;
                this.scheduleItemData[categoryId].autoUpdateItem = autoUpdateItem;

                if (Object.keys(this.scheduleData).length > 0) {
                    this.scheduleItemData[categoryId].schedule = this.scheduleData;
                }
            } else if (type == 'scheduleItems') {
                if (this.scheduleItemData[categoryId].items) {
                    let itemId = items.id;
                    let item = this.scheduleItemData[categoryId].items?.find((item: any) => item.id == itemId);
                    if (!item) {
                        this.scheduleItemData[categoryId].items.push(items);
                    }
                } else {
                    this.scheduleItemData[categoryId].items = [items];
                }
            }
        }
        console.log(this.scheduleItemData);

        this.setRails(categoryId, true);
    }

    removeItemSchdeuleFilter(categoryId: string, itemId: any, page: any) {
        console.log(categoryId, itemId, page);
        console.log(this.scheduleItemData[categoryId]);

        if (page == 'schedule') {
            delete this.scheduleItemData[categoryId];
        } else if (page == 'scheduleItems') {
            // this.scheduleItemData[categoryId].items = this.scheduleItemData[categoryId].items.filter(
            //     (item: any) => item.id != itemId
            // );
            let index = this.scheduleItemData[categoryId]?.items.findIndex((item: any) => item.id == itemId);
            console.log(index);

            if (index !== -1 && index !== undefined) {
                // delete this.scheduleItemData[categoryId].items[index].schedule;
                this.scheduleItemData[categoryId].items.splice(index, 1);
            }
            console.log('SFLHIkS:NG;lSNgk;an;igkbaei', this.scheduleItemData);
        }
    }

    getSelectedRails() {
        return this.selectedRails;
    }

    setRails(id: string, set: boolean) {
        if (set) {
            if (this.scheduleItemData[id]) {
                this.selectedRails[id] = this.scheduleItemData[id];
            } else {
                this.selectedRails[id] = {};
            }
        } else {
            delete this.selectedRails[id];
            this.removeItemSchdeuleFilter(id, '', 'schedule');
        }
    }

    resetSelectedRails() {
        this.selectedRails = {};
    }

    clearStore() {
        this.scheduleData = {};
        this.scheduleItemData = {};
        this.selectedRails = {};

        this.platformData = [];
        this.productData = [];
        this.screenData = [];
    }

    clearData() {
        this.scheduleData = {};
        this.scheduleItemData = {};
        this.selectedRails = {};
    }

    getPlatformDropdownData() {
        return this.platformData;
    }

    setPlatformDropdownData(data: any) {
        this.platformData = data;
    }

    getProductDropdownData() {
        return this.productData;
    }

    setProductDropdownData(data: any) {
        this.productData = data;
    }

    getScreenDropdownData() {
        return this.screenData;
    }

    setScreenDropdownData(data: any) {
        this.screenData = data;
    }

    updateSchedule(categoriesData: any, screens: any, products: any, platforms: any) {
        const url = `${environment.apiUrlDomain}/publish/content`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        let data: any = {
            publish: {
                categories: categoriesData,
            },
            screens: screens,
            products: products,
            platforms: platforms,
        };

        this.http
            .postRequest(url, headers, data)
            .pipe(
                tap((response: any) => {
                    if (response.status == 201) {
                        this.scheduleSubject.next({
                            type: 'SCHEDULE_CATGEORIES_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    console.log(response);
                }),
                catchError((error) => {
                    this.scheduleSubject.next({
                        type: 'SCHEDULE_CATGEORIES_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }

    updateAddItem(categoriesData: any, products: any, platforms: any) {
        const url = `${environment.apiUrlDomain}/validate/page`;
        console.log('categoriesData,products,platforms', categoriesData, products, platforms);

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        let data: any = {
            categories: categoriesData,
            products: products,
            platforms: platforms,
        };

        this.http
            .postRequest(url, headers, data)
            .pipe(
                tap((response: any) => {
                    if (response.status == 201) {
                        this.scheduleSubject.next({
                            type: 'ADD_CATGEORIES_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    console.log(response);
                }),
                catchError((error) => {
                    this.scheduleSubject.next({
                        type: 'ADD_CATGEORIES_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }

    updateItemsSchedule(productId: any, platformId: any, screenId: any, categoryId: any, itemCategoriesData: any) {
        const url = `${environment.apiUrlDomain}/publishitems?productId=${productId}&platformId=${platformId}&screenId=${screenId}&categoryId=${categoryId}`;
        console.log(productId, platformId, screenId, categoryId, itemCategoriesData);

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        let data: any = {
            items: itemCategoriesData,
            screenId: screenId,
            productId: productId,
            platformId: platformId,
            categoryId: categoryId,
        };

        console.log(data);

        this.http
            .patchRequest(url, headers, data)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.scheduleSubject.next({
                            type: 'SCHEDULE_ITEMS_CATGEORIES_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    console.log(response);
                }),
                catchError((error) => {
                    this.scheduleSubject.next({
                        type: 'SCHEDULE_ITEMS_CATGEORIES_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }

    getPublishData(productId: string, platformId: string = '', screenId: string = '', checkbox: boolean) {
        let url = '';
        let schedule: boolean = false;

        // if (date.length == 0 && startTime.length == 0 && endTime.length == 0) {
        url = `${environment.apiUrlDomain}/preview/screens/rails?productId=${productId}&platformId=${platformId}&screenId=${screenId}&status=${checkbox}&schedule=${schedule}`;
        // } else {
        //     url = `${environment.apiUrlDomain}/preview/screens/rails?productId=${productId}&platformId=${platformId}&screenId=${screenId}&status=${checkbox}&day=${day}&date=${currentDate}&startTime=${starttime}&endTime=${endtime}`;
        // }

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.scheduleSubject.next({
                            type: 'PUBLISH_SEARCH_DATA_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    console.log(response);
                }),
                catchError((error) => {
                    this.scheduleSubject.next({
                        type: 'PUBLISH_SEARCH_DATA_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }

    getPublishItemsData(productId: string, platformId: string = '', screenId: string = '', categoryId: string = '') {
        let url = '';

        // if (date.length == 0 && startTime.length == 0 && endTime.length == 0) {
        url = `${environment.apiUrlDomain}/preview/screens/rail/items?productId=${productId}&platformId=${platformId}&screenId=${screenId}&categoryId=${categoryId}`;
        // } else {
        //     url = `${environment.apiUrlDomain}/preview/screens/rails?productId=${productId}&platformId=${platformId}&screenId=${screenId}&status=${checkbox}&day=${day}&date=${currentDate}&startTime=${starttime}&endTime=${endtime}`;
        // }

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.scheduleSubject.next({
                            type: 'PUBLISH_ITEMS_DATA_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    console.log(response);
                }),
                catchError((error) => {
                    this.scheduleSubject.next({
                        type: 'PUBLISH_ITEMS_DATA_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }

    getAndroidNoteData() {
        if (Object.keys(this.androidNoteData).length > 0) {
            this.scheduleSubject.next({
                type: 'PUBLISH_ANDROID_NOTE_SUCCESSFUL',
                data: this.androidNoteData,
            });
        } else {
            const url = `${environment.apiUrlDomain}/service/master-config?key=multi-platform-publish`;

            const headers = {
                'Content-Type': 'application/json',
                'x-access-token': this.authData.token,
            };

            this.http
                .getRequest(url, headers)
                .pipe(
                    tap((response: any) => {
                        if (response.status == 200) {
                            this.androidNoteData = response.body;
                            this.scheduleSubject.next({
                                type: 'PUBLISH_ANDROID_NOTE_SUCCESSFUL',
                                data: response.body,
                            });
                        }
                        console.log(response);
                    }),
                    catchError((error) => {
                        this.scheduleSubject.next({
                            type: 'PUBLISH_ANDROID_NOTE_FAILED',
                            data: error,
                        });
                        throw error;
                    }),
                    shareReplay()
                )
                .subscribe();
        }
    }

    getPlatformData(productId: any) {
        let url = `${environment.apiUrlDomain}/platforms`;
        const queryParams = [];
        queryParams.push(`pageSize=100`);
        if (productId) {
            queryParams.push(`productId=${productId}`);
        }
        if (queryParams.length > 0) {
            url += `?${queryParams.join('&')}`;
        }

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.scheduleSubject.next({
                            type: 'PLATFORM_DROPDOWN_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    console.log(response);
                }),
                catchError((error) => {
                    this.scheduleSubject.next({
                        type: 'PLATFORM_DROPDOWN_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }

    getScreenData(productId: any) {
        let url = `${environment.apiUrlDomain}/screens`;
        const queryParams = [];
        queryParams.push(`pageSize=100`);

        if (productId) {
            queryParams.push(`productId=${productId}`);
        }
        if (queryParams.length > 0) {
            url += `?${queryParams.join('&')}`;
        }

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.scheduleSubject.next({
                            type: 'SCREEN_DROPDOWN_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    console.log(response);
                }),
                catchError((error) => {
                    this.scheduleSubject.next({
                        type: 'SCREEN_DROPDOWN_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }
}
